import { WorkModel } from '@Entities/work/work'
import { setItemToArrayByIndex } from '@App/helpers/work-entities/removers'
import { useContext } from 'react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { PublisherModel } from '@Entities/work/publisher-model'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'
import { WriterModel } from '@Entities/work/writer-model'

const usePublisherService = () => {
    const { workStore } = useContext<RootStore>(StoresContext)

    const workDraftFromLocal = workStore.workDraftLocal

    const updatePublisherShare = (publisherModel: OriginalPublisherModel, newValue: number) => {
        if (!workDraftFromLocal) {
            return
        }

        const updatedPublisherModel: OriginalPublisherModel = {
            ...publisherModel,
            amend: true,
            publisherShare: newValue,
        }

        const indexOfOP = workDraftFromLocal.originalPublishers
            .map((op: OriginalPublisherModel) => op.localId)
            .indexOf(publisherModel.localId)

        const updatedOpArray = setItemToArrayByIndex(
            workDraftFromLocal.originalPublishers,
            +indexOfOP,
            updatedPublisherModel
        )

        const updatedWorkDraft: WorkModel = {
            ...workDraftFromLocal,
            originalPublishers: updatedOpArray,
        }

        workStore.setWorkDraftToLocal(updatedWorkDraft)
    }

    const updateAdministratorPublisherShare = (
        originalPublisherModel: OriginalPublisherModel,
        adminModel: PublisherModel,
        newValue: number
    ) => {
        if (!workDraftFromLocal) {
            return
        }

        const updatedAP: PublisherModel = {
            ...adminModel,
            amend: true,
            publisherShare: newValue,
        }

        const indexOfAP = originalPublisherModel.administratorPublishers
            .map((ap: PublisherModel) => ap.localId)
            .indexOf(adminModel.localId)

        const updatedApArray = setItemToArrayByIndex(
            originalPublisherModel.administratorPublishers,
            +indexOfAP,
            updatedAP
        )

        const updatedParentOp = {
            ...originalPublisherModel,
            administratorPublishers: updatedApArray,
        }

        const indexOfOp = workDraftFromLocal.originalPublishers
            .map((op: OriginalPublisherModel) => op.localId)
            .indexOf(originalPublisherModel.localId)

        const updatedOpArray = setItemToArrayByIndex(workDraftFromLocal.originalPublishers, +indexOfOp, updatedParentOp)

        const updatedWorkDraft: WorkModel = {
            ...workDraftFromLocal,
            originalPublishers: updatedOpArray,
        }

        workStore.setWorkDraftToLocal(updatedWorkDraft)
    }

    const removeLinkedWriter = (publisher: OriginalPublisherModel, removingWriter: WriterModel) => {
        const data = publisher
        const editingOPId = data.localId

        if (!workDraftFromLocal || !editingOPId || !removingWriter) {
            return
        }

        const originalPublishers = workDraftFromLocal.originalPublishers
        const indexOfOP = originalPublishers.map((op: OriginalPublisherModel) => op.localId).indexOf(editingOPId)

        const updatedWriters: WriterModel[] = data.writers.filter((writer: WriterModel) => {
            if (removingWriter.localId === writer.localId) {
                return
            }
            return writer
        })

        const updatedOriginalPublisher: OriginalPublisherModel = {
            ...data,
            id: data.id,
            amend: data.amend,
            localId: editingOPId,
            publisherName: data.publisherName,
            ipiNumber: data.ipiNumber,
            publisherShare: data.publisherShare,
            administratorPublishers: data.administratorPublishers,
            writers: updatedWriters,
        }

        const updatedOPArray = setItemToArrayByIndex(originalPublishers, +indexOfOP, updatedOriginalPublisher)

        const updatedWorkDraft: WorkModel = {
            ...workDraftFromLocal,
            originalPublishers: updatedOPArray,
        }
        workStore.setWorkDraftToLocal(updatedWorkDraft)
    }

    return { updatePublisherShare, updateAdministratorPublisherShare, removeLinkedWriter }
}

export default usePublisherService
